import { configureStore, Middleware } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { answersSlice, phonesSlice, rootSaga, scenarioSlice, stepSlice, progressSlice, referrerSlice } from '../state'
import createSagaMiddleware from 'redux-saga'
import { redirectionUrlSlice } from '../state/redirection-url-slice'

export interface StoreOptions<S = Record<string, unknown>> {
  withLogger: boolean
  preloadedState?: S
}

const defaultOptions: StoreOptions = {
  withLogger: !true,
}

export const rootReducer = {
  scenario: scenarioSlice.reducer,
  phones: phonesSlice.reducer,
  step: stepSlice.reducer,
  answers: answersSlice.reducer,
  progress: progressSlice.reducer,
  referrerUrl: referrerSlice.reducer,
  redirectionUrl: redirectionUrlSlice.reducer,
}

export const initStore = (storeOptions = defaultOptions) => {
  const { withLogger, preloadedState } = storeOptions
  const sagaMiddleware = createSagaMiddleware()

  const middlewares: Array<Middleware> = [sagaMiddleware]

  withLogger && middlewares.push(logger)

  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
  })

  sagaMiddleware.run(rootSaga)

  return store
}
